// index.web.js — VERSION QUI MARCHE À TOUS LES COUPS (2025)
import 'babel-polyfill';
import 'url-polyfill';
import { AppRegistry, Platform } from 'react-native';
import App from './src/App';

// Fonction qui attend que le DOM soit prêt + #react-root existe
const bootstrap = () => {
  // 1. On attend que le body existe
  if (!document.body) {
    return requestAnimationFrame(bootstrap);
  }

  // 2. On attend que #react-root existe
  const rootTag = document.getElementById('react-root');
  if (!rootTag) {
    return requestAnimationFrame(bootstrap);
  }

  // 3. On monte l’app
  AppRegistry.registerComponent('App', () => App);
  AppRegistry.runApplication('App', { rootTag });

  // 4. On enlève le splashscreen (proprement)
  const splash = document.getElementById('splashscreen');
  if (splash) {
    splash.style.opacity = '0';
    splash.style.transition = 'opacity 0.6s ease-out';
    setTimeout(() => {
      splash.style.display = 'none';
    }, 600);
  }
};

// Lancement sécurisé
if (Platform.OS === 'web') {
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', bootstrap);
  } else {
    bootstrap();
  }
} else {
  // Mobile : comportement classique
  AppRegistry.registerComponent('App', () => App);
  AppRegistry.runApplication('App', {
    rootTag: document.getElementById('react-root'),
  });
}

// === FONTS (inchangé) ===
const fonts = [
  { icon: require('./resources/icomoon.ttf'), family: 'icomoon' },
];

const iconFontStyles = fonts
  .map(font => `@font-face { src: url(${font.icon}); font-family: ${font.family}; }`)
  .join('\n');

const style = document.createElement('style');
style.type = 'text/css';
style.appendChild(document.createTextNode(iconFontStyles));
document.head.appendChild(style);